import { ref, watch, computed, onMounted } from "@vue/composition-api";
import store from "@/store";
import { formatCurrency } from "@core/utils/filter";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ability from "@/libs/acl/ability";

export default function useRefundsList() {
  // Use toast
  const toast = useToast();

  const refRefundListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: "refund_number", label: "編號", class: 'sticky-column', sortable: true },
    { key: "refund_date", class: 'sticky-column', label: "退款日期", sortable: true },
    { key: "actions", class: 'sticky-column', label: "操作" },
    { key: "show_details", label: "退款項目" },
    { key: "customer.name_cn", label: "單據抬頭" },
    { key: "receipt.receipt_number", label: "收據編號"},
    // { key: "project_name", label: "項目名稱", sortable: true },
    { key: "address", label: "施工地址", sortable: true },
    { key: "amount", label: "金額", sortable: true, formatter: formatCurrency },
    
/*     { key: "name_en", label: "單據抬頭" },
    { key: "mobile", label: "聯絡電話" },
    { key: "email", label: "電郵地址"}, */
    { key: "created_at", label: "創建日期", sortable: true },
  ];
  const perPage = ref(10);
  const totalRow = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("refund_date");
  const isSortDirDesc = ref(true);

  const dataMeta = computed(() => {
    const localItemsCount = refRefundListTable.value
      ? refRefundListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalRow.value,
    };
  });

  const refetchData = () => {
    refRefundListTable.value.refresh();
  };

  const refundsList = ref(null);

  const filter_customer_id = ref(null);
  const filter_receipt_id = ref(null);
  const filter_project_id = ref(null);

  watch(
    [currentPage, perPage, searchQuery, filter_customer_id, filter_receipt_id, filter_project_id],
    () => {
      refetchData();
    }
  );
  const loading = ref(false);
  const fetchRefunds = (ctx, callback) => {
    loading.value = true;
    store
      .dispatch("refund/fetchRefunds", {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        receipt_id: filter_receipt_id.value,
        customer_id: filter_customer_id.value,
        project_id: filter_project_id.value,
      })
      .then((response) => {
        const { refunds, total } = response.data;
        callback(refunds);
        totalRow.value = total;
        refundsList.value = refunds
        loading.value = false;
      })
      .catch((err) => {
        console.log(err);
        toast({
          component: ToastificationContent,
          props: {
            title: "獲取貸款清單時出錯",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  const customerOptions = ref([]);
  const receiptOptions = ref([]);
  const projectOptions = ref([]);

  const refetchOption = () => {
    store
      .dispatch("app/fetchOptionList", {
        receipts:true,
        customers: true,
        projects: true,
      })
      .then((response) => {
        receiptOptions.value = response.data.receipts;
        customerOptions.value = response.data.customers;
        projectOptions.value = response.data.projects;
      });
  };


  onMounted(() => {
    refetchData();
    refetchOption();
  });

  return {
    fetchRefunds,
    tableColumns,
    perPage,
    currentPage,
    totalRow,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refundsList,
    refRefundListTable,
    ability,
    refetchData,
    filter_customer_id,
    filter_receipt_id,
    filter_project_id,
    customerOptions,
    receiptOptions,
    projectOptions,
    loading,
  };
}
